import { render, staticRenderFns } from "./vue-cropper.vue?vue&type=template&id=2b746030&scoped=true&"
import script from "./vue-cropper.vue?vue&type=script&lang=js&"
export * from "./vue-cropper.vue?vue&type=script&lang=js&"
import style0 from "./vue-cropper.vue?vue&type=style&index=0&id=2b746030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b746030",
  null
  
)

export default component.exports